import dayjs from 'dayjs'

import httpClient, { catchError } from '@emmacare/common/api/httpClient'

import {
  CARE_PLAN_REPORT_GET_EXPORT_LIST,
  CARE_PLAN_REVIEW_EXPORT_PDF_GET,
  DATE_TIME_FORMAT_FOR_SERVER,
  HTTP_ACCEPTED,
  REPORT_SUCCESS_UPLOAD_MESSAGE
} from 'src/constants'
import { showSuccessModal } from 'src/services/dialogs'
import { exportReport, getFileName } from 'src/utils/Functions'

// TODO: make common solution with exportPatientMeasurementReport
export const exportCarePlanReport = async (config = {}) => {
  const { params = {}, query = {} } = config

  try {
    const response = await httpClient.request({
      method: 'get',
      url: {
        pathname: CARE_PLAN_REPORT_GET_EXPORT_LIST,
        params,
        query
      },
      isDownload: true
    })
    const { status } = response

    if (status === HTTP_ACCEPTED) {
      showSuccessModal({
        content: REPORT_SUCCESS_UPLOAD_MESSAGE,
        centered: true
      })
    } else {
      const { data, headers } = response
      const content = headers['content-disposition']
      const fileNameDefault = ''
      const fileName = getFileName(content, fileNameDefault)
      const link = document.createElement('a')

      link.setAttribute('href', window.URL.createObjectURL(new Blob([data])))
      link.setAttribute('download', fileName)

      document.body.appendChild(link)

      link.click()
    }
  } catch (err) {
    catchError(err)

    return false
  }
}

export const exportCarePlanReviewPDF = async (config = {}) => {
  const updConfig = {
    pathname: CARE_PLAN_REVIEW_EXPORT_PDF_GET,
    ...config
  }

  await exportReport(
    updConfig,
    `patient_care_plan_${dayjs().format(DATE_TIME_FORMAT_FOR_SERVER)}.pdf`,
    true
  )
}
